import { render, staticRenderFns } from "./qbyy.vue?vue&type=template&id=6754419f&scoped=true"
import script from "./qbyy.vue?vue&type=script&lang=js"
export * from "./qbyy.vue?vue&type=script&lang=js"
import style0 from "./qbyy.vue?vue&type=style&index=0&id=6754419f&prod&lang=less&scoped=true"
import style1 from "./qbyy.vue?vue&type=style&index=1&id=6754419f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6754419f",
  null
  
)

export default component.exports